import { Prompt } from "./main";
import json_schema from "./disciplineWF.json";

const systemContent = `Тебе нужно принять роль врача по специальности {speciality} и одновременно тестолога - методиста.`;
// Да. Сказано именно продублировать одно и то же 2 раза. Это не ошибка
const userContent = `Тебе нужно принять роль ведущего врача специальности "{speciality}" и преподавателя медицинского университета.
Я дам тебе для анализа заголовок небольшого фрагмента медицинского текста, а тебе нужно по этому заголовку классифицировать этот фрагмент по двум направлениям: 
1) Дисциплины: {disciplineList}. 
2) Трудовые функции: {wfList}.

При классификации ты должен использовать ТОЛЬКО эти названия Дисциплин и Трудовых функций, иначе получишь ШТРАФ.

У трудовых функций первый элемент списка - код ТФ, второй - название ТФ.

Вот заголовок фрагмента текста: {title}
`;
export default new Prompt({
  messages: {
    system: systemContent,
    user: userContent
  },
  params: {
    temperature: 0,
    response_format: {
      type: "json_schema",
      json_schema
    }
  }
});
